import { styled, css } from "../../../styled-components";

function computeNavBarHeight(hasSearchBar: boolean, hasPivot: boolean, theme: any, hasQuotaBar: boolean, hasOfflineBanner: boolean) {
    let result = theme.navBar.height + theme.navBar.largeTitleHeight;
    if (hasSearchBar) {
        result += theme.searchBar.heightWithPadding;
    }
    if (hasPivot) {
        result += theme.pivot.height + theme.pivot.bottomMargin;
    }
    if (hasQuotaBar) {
        result += theme.quotaBar.height;
    }
    if (hasOfflineBanner) {
        result += theme.offlineBanner.height;
    }

    return result;
}

export const PositionWrapper = styled.div`
    position: absolute;

    pointer-events: auto;

    left: var(--safe-area-inset-left);
    right: var(--safe-area-inset-right);
    top: var(--safe-area-inset-top);
`;

interface NavBarWrapperProps {
    hasSearchBar: boolean;
    hasPivot: boolean;
    hasQuotaBar: boolean;
    hasOfflineBanner: boolean;
    tabletOrBuilder: boolean;
    inTabletModal: boolean;
}

export const NavBarWrapper = styled.div<NavBarWrapperProps>`
    position: ${p => (p.tabletOrBuilder ? "absolute" : "fixed")};
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;

    ${p =>
        p.inTabletModal &&
        css`
            border-radius: 12px 12px 0px 0px;
        `};

    pointer-events: none;

    overflow: hidden;

    left: 0;
    right: 0;

    z-index: 20;

    padding-top: var(--safe-area-inset-top);
    padding-left: var(--safe-area-inset-left);
    padding-right: var(--safe-area-inset-right);
    height: calc(
        var(--safe-area-inset-top) + ${p => computeNavBarHeight(p.hasSearchBar, p.hasPivot, p.theme, p.hasQuotaBar, p.hasOfflineBanner)}px
    );

    top: 0;
`;

export const QuotaBar = styled.div`
    height: 60px;
    padding: 12px 20px;

    ${p => p.theme.fontStyles.Header4}
    display: flex;
    align-items: center;
    text-align: center;

    background-color: ${p => p.theme.quotaBar.bgColor};
    color: ${p => p.theme.fgColorDark};
`;
